import Flickity from 'flickity-imagesloaded'

export const settings = {
  selector: '.js-property-gallery',
  cellSelector: '.js-property-gallery-slide'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const cellElements = Array.from( element.querySelectorAll( settings.cellSelector ))
  if ( cellElements.length > 0 ) {
    initCarousel( element )
  }
}

/**
 *
 * @param {DOMNode} carouselEl
 */
function initCarousel( carouselEl ) {
  // eslint-disable-next-line no-unused-vars
  const carousel = new Flickity( carouselEl, {
    cellSelector: settings.cellSelector,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    wrapAround: true,
    lazyLoad: 1,
    setGallerySize: false,
    arrowShape: {
      x0: 20,
      x1: 70, y1: 40,
      x2: 70, y2: 0,
      x3: 70
    }
  })
}
